import { ManualModeProps } from '../types';
import { ELoginEvents, ELoginMethods } from '../../Helper/enums';
import React, { useEffect, useState } from 'react';
import LoginButton from '../LoginButton';
import LoginInput from '../LoginInput';

function UsernamePasswordMode({
    submit,
    loginButtonClickWrapper,
    trackLoginEvent
}: ManualModeProps) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const isDisabled = !username.trim().length || !password.trim().length;

    useEffect(() => {
        const trackLogin = async () => {
            if (trackLoginEvent) {
                await trackLoginEvent(
                    ELoginEvents.LOGIN_SCREEN_PRESENTED,
                    ELoginMethods.USERNAME
                );
            }
        };
        trackLogin();
    }, []);

    const login = () => {
        submit({
            authMethod: ELoginMethods.USERNAME,
            userName: username,
            userPassword: password
        });
    };

    const loginButtonClicked = async (callback: Function) => {
        if (trackLoginEvent) {
            await trackLoginEvent(
                ELoginEvents.LOGIN_APPROVAL,
                ELoginMethods.USERNAME
            );
        }
        loginButtonClickWrapper(callback, ELoginMethods.USERNAME, ELoginEvents.PLAYER_PASSWORD_BUTTON_CLICKED);
    };

    const handleFormSubmit = async (
        event: React.FormEvent<HTMLFormElement>
    ) => {
        event.preventDefault();
        if (isDisabled) return;
        await loginButtonClicked(login);
    };

    return (
        <form onSubmit={handleFormSubmit} style={{ width: '100%' }}>
            <LoginInput
                type="text"
                placeholder="Username"
                value={username}
                setValue={setUsername}
            />
            <LoginInput
                type="password"
                placeholder="Password"
                value={password}
                setValue={setPassword}
            />
            <LoginButton
                type="submit"
                variant="white"
                text="Login"
                isDisabled={isDisabled}
            />
        </form>
    );
}

export default UsernamePasswordMode;
